import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Euro } from "lucide-react";
import TarifsManager from "@/features/ventes/components/tarifs/TarifsManager";

export const Route = createFileRoute("/_app/ventes/tarifs/")({
  loader: requirePermission(PERMISSIONS.VENTES.TARIFS.VIEW),
  staticData: {
    title: "Tarifs",
    icon: Euro,
    tab_icon: Euro,
    permission: PERMISSIONS.VENTES.TARIFS.VIEW,
    module: "ventes",
    order: 60,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Gestion des tarifs",
  },
  component: TarifsManager,
});
